import { render, staticRenderFns } from "./MiniMetricClass.vue?vue&type=template&id=2ba56b4b&scoped=true"
import script from "./MiniMetricClass.vue?vue&type=script&lang=js"
export * from "./MiniMetricClass.vue?vue&type=script&lang=js"
import style0 from "./MiniMetricClass.vue?vue&type=style&index=0&id=2ba56b4b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba56b4b",
  null
  
)

export default component.exports